import { LegalLayout, LegalSection } from "../components/site/LegalLayout";
import { WHATSAPP_DISPLAY } from "../lib/site";

export default function Termos() {
  return (
    <LegalLayout title="Termos de Serviço" updatedAt="18 de agosto de 2026">
      <p>
        Bem-vindo ao Delivery Maracás. Estes Termos de Serviço ("Termos") regem o uso do
        aplicativo, do site www.deliverymaracas.com.br e dos serviços oferecidos pela plataforma
        Delivery Maracás ("Plataforma", "nós"). Ao criar uma conta, fazer um pedido ou utilizar
        nossos serviços, você declara ter lido, compreendido e concordado com estes Termos.
      </p>

      <LegalSection n="1" title="Sobre a plataforma">
        <p>
          O Delivery Maracás é uma plataforma de intermediação que conecta consumidores a lojas,
          restaurantes, mercados, farmácias, prestadores de serviços e entregadores na cidade de
          Maracás-BA e região. Não produzimos os produtos nem prestamos diretamente os serviços de
          beleza e saúde anunciados; atuamos como intermediários tecnológicos entre as partes.
        </p>
      </LegalSection>

      <LegalSection n="2" title="Cadastro e conta">
        <p>
          Para utilizar a Plataforma é necessário criar uma conta com informações verdadeiras,
          completas e atualizadas. Você é responsável por manter a confidencialidade das suas
          credenciais e por todas as atividades realizadas em sua conta. É necessário ter ao menos
          18 anos ou estar assistido por responsável legal.
        </p>
      </LegalSection>

      <LegalSection n="3" title="Pedidos e pagamentos">
        <p>
          Os preços, taxas de entrega e disponibilidade dos produtos são definidos pelas lojas
          parceiras e exibidos no momento do pedido. Ao confirmar um pedido, você concorda em pagar
          o valor total apresentado, incluindo eventuais taxas de serviço e entrega.
        </p>
        <p>
          Os pagamentos podem ser processados no app (cartão, Pix) ou diretamente na entrega,
          conforme as opções disponibilizadas por cada loja. Os pagamentos online são tratados por
          processadores terceirizados; não armazenamos os dados completos do seu cartão.
        </p>
      </LegalSection>

      <LegalSection n="4" title="Entregas e agendamentos">
        <p>
          Os prazos de entrega são estimativas e podem variar conforme distância, demanda, clima e
          disponibilidade dos entregadores. Para serviços agendados em casa (como salão de beleza,
          manicure e atendimentos clínicos), o horário é combinado entre o usuário e o prestador
          pela Plataforma.
        </p>
      </LegalSection>

      <LegalSection n="5" title="Cancelamentos e reembolsos">
        <p>
          Você poderá cancelar um pedido enquanto a loja ainda não o tiver aceitado ou iniciado o
          preparo. Após esse momento, o cancelamento fica sujeito às políticas da loja parceira.
          Reembolsos, quando aplicáveis, seguem o meio de pagamento original e os prazos do
          respectivo processador.
        </p>
      </LegalSection>

      <LegalSection n="6" title="Responsabilidades do usuário">
        <p>
          Você concorda em utilizar a Plataforma de forma lícita, não publicar conteúdo ofensivo,
          fraudulento ou que viole direitos de terceiros, e fornecer informações corretas de
          endereço e contato para a realização das entregas e serviços.
        </p>
      </LegalSection>

      <LegalSection n="7" title="Lojistas e parceiros">
        <p>
          As lojas parceiras são responsáveis pela qualidade, procedência, validade e conformidade
          dos produtos e serviços ofertados, bem como pelo cumprimento das obrigações fiscais e
          sanitárias aplicáveis. O cadastro de lojas é feito pelo Painel do Lojista.
        </p>
      </LegalSection>

      <LegalSection n="8" title="Propriedade intelectual">
        <p>
          A marca, o logotipo, o layout, os textos e o software do Delivery Maracás são protegidos
          por direitos de propriedade intelectual. É vedada a reprodução, cópia ou uso sem
          autorização prévia e por escrito.
        </p>
      </LegalSection>

      <LegalSection n="9" title="Limitação de responsabilidade">
        <p>
          Na máxima extensão permitida em lei, o Delivery Maracás não se responsabiliza por danos
          decorrentes de atos das lojas parceiras, dos entregadores ou de terceiros, nem por
          indisponibilidades temporárias da Plataforma por motivos técnicos ou de força maior.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Alterações dos Termos">
        <p>
          Podemos atualizar estes Termos periodicamente. A versão vigente estará sempre disponível
          nesta página, com a data da última atualização. O uso contínuo da Plataforma após
          alterações representa a sua concordância com os novos Termos.
        </p>
      </LegalSection>

      <LegalSection n="11" title="Legislação e foro">
        <p>
          Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da comarca de
          Maracás-BA para dirimir quaisquer controvérsias, com renúncia a qualquer outro, por mais
          privilegiado que seja.
        </p>
      </LegalSection>

      <LegalSection n="12" title="Contato">
        <p>
          Dúvidas sobre estes Termos podem ser enviadas para contato@deliverymaracas.com.br ou pelo
          WhatsApp {WHATSAPP_DISPLAY}.
        </p>
        <p className="text-sm text-maraca-navy/50">
          Razão social: [Razão Social] — CNPJ: [00.000.000/0001-00] — Maracás/BA.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
